import React from "react";

const features = [
	{
		icon: "☕",
		title: "specialty, always",
		description:
			"solo café de especialidad de origen único. si no nos gustaría tomarlo, no te lo servimos.",
		color: "#2D6B6B",
	},
	{
		icon: "🥛",
		title: "cold foam game strong",
		description:
			"cold foams hechos en casa: vainilla, fresa, biscoff, banana. tu latte nunca volverá a ser igual.",
		color: "#F07E2A",
	},
	{
		icon: "✌️",
		title: "made your way",
		description:
			"leche de almendra, avena o coco. sin azúcar, con shot extra, dulce o intenso. tú mandas.",
		color: "#E84023",
	},
	{
		icon: "🌀",
		title: "always something new",
		description:
			"bebidas de temporada, drops sorpresa y combinaciones que probablemente verás primero en nuestro insta.",
		color: "#F5C917",
	},
];

const Features = () => {
	return (
		<section className="features">
			<div className="container">
				<div className="section-header">
					<span className="section-tag">why dossis</span>
					<h2 className="section-title">
						we don't play{" "}
						<span className="text-accent">by the rules</span>
					</h2>
					<p className="section-subtitle">
						cuatro razones por las que te vas a volver regular
					</p>
				</div>

				<div className="features__grid">
					{features.map((f, i) => (
						<div className="features__card" key={i}>
							<div
								className="features__icon"
								style={{
									backgroundColor: f.color + "20",
									color: f.color,
								}}
							>
								{f.icon}
							</div>
							<h3 className="features__card-title">{f.title}</h3>
							<p className="features__card-desc">
								{f.description}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Features;
